// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2JKmA","footer":"ModalError_footer__aHji8"};